import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { company, navigation, services } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-lg bg-yellow-400 flex items-center justify-center">
                <span className="font-black text-slate-900 text-lg">DK</span>
              </div>
              <div>
                <div className="font-bold text-white">{company.name}</div>
                <div className="text-xs text-slate-400 -mt-0.5">{company.experience}</div>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed max-w-md">
              Vakkundig en professioneel latex spuitwerk voor particulieren en
              bedrijven in heel Nederland. Strak resultaat, eerlijke prijs.
            </p>

            <div className="mt-6 space-y-2">
              <a href={`tel:${company.phoneRaw}`} className="flex items-center gap-2 text-sm hover:text-yellow-400 transition-colors">
                <Phone className="w-4 h-4" /> {company.phone}
              </a>
              <a href={`mailto:${company.email}`} className="flex items-center gap-2 text-sm hover:text-yellow-400 transition-colors">
                <Mail className="w-4 h-4" /> {company.email}
              </a>
              <div className="flex items-center gap-2 text-sm">
                <MapPin className="w-4 h-4" /> {company.address}
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">Navigatie</h4>
            <ul className="space-y-2">
              {navigation.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-sm text-slate-400 hover:text-yellow-400 transition-colors">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">Diensten</h4>
            <ul className="space-y-2">
              {services.slice(0, 6).map((s) => (
                <li key={s.title}>
                  <a href="#diensten" className="text-sm text-slate-400 hover:text-yellow-400 transition-colors">
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} {company.name}. Alle rechten voorbehouden.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-slate-500 hover:text-slate-300 transition-colors">
              Privacybeleid
            </a>
            <a href="#" className="text-xs text-slate-500 hover:text-slate-300 transition-colors">
              Algemene voorwaarden
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
